
import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition-colors">
          <Globe className="h-5 w-5 text-gray-600" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[120px] p-0 bg-white" align="end">
        <div className="flex flex-col text-sm font-medium">
          <button 
            onClick={() => setLanguage('en')}
            className={`px-4 py-2 text-left hover:bg-gray-50 ${language === 'en' ? 'bg-gray-50' : ''}`}
          >
            English
          </button>
          <button 
            onClick={() => setLanguage('de')}
            className={`px-4 py-2 text-left hover:bg-gray-50 ${language === 'de' ? 'bg-gray-50' : ''}`}
          >
            Deutsch
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default LanguageSwitcher;
